import React from 'react';
import Flexbox from 'flexbox-react';
import BadgedItemList from 'components/page/process/variableRetrieval/BadgedItemList';
import ListItem from 'components/core/ListItem';
import RollupError from 'components/core/RollupError';

export default class OuputDatastreamsList extends BadgedItemList {

    renderItem = (name, value, selected) => {

        let outputDatastreamBadge = <span />;
        if (!this.props.hideBadges) {
            outputDatastreamBadge = <span className="badged-item" style={this.props.getBackgroundColor(this.props.type, name)} />;
        }

        let mappings = '(empty)';
        if (this.props.process.variable_retrieval.output_datastream_variable_mappings[name] &&
            Object.keys(this.props.process.variable_retrieval.output_datastream_variable_mappings[name]).length > 0) {
            mappings = null;
        }

        return (
            <ListItem
                key={name}
                name={name}
                className={this.getItemClassName()}
                selected={selected}
                onClick={this.onClick}
                onDoubleClick={this.props.onDoubleClick}
            >
                <Flexbox flexDirection="row" alignItems="center" title={'Double click to edit'}>
                    {outputDatastreamBadge}
                    <span style={{ whiteSpace: 'nowrap', flexGrow: 1 }}>
                        <span className={'badged-item-label'}>
                            <RollupError
                                fieldPath={[...this.props.baseFieldPath, name]}
                                processErrors={this.props.processErrors}
                                process={this.props.process}
                                includeChildren
                            />
                            {this.renderEntity(name, mappings)}
                        </span>
                    </span>
                </Flexbox>
            </ListItem>
        );
    };

    renderItems(filteredIds, selectedItems) {
        const invisibleStyle = { backgroundColor: 'white', border: '1px solid #e8e8e8', width: '15px', height: '15px', marginTop: '-1px' };
        const items = super.renderItems(filteredIds, selectedItems);
        if (!this.props.hideBadges && items.length > 0) {
            items.push(
                <Flexbox key="undefined" flexDirection="row" alignItems="center" padding="4px 7px">
                    <span className="badged-item" style={invisibleStyle} />
                    <span className="legend badged-item-label">No output datastream defined</span>
                </Flexbox>
            );
        }
        return items;
    }

}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/OutputDatastreamsList.js